import { createContext, useState } from 'react'

import { useParams } from 'react-router-dom'

import { IItemTraceability } from '../../sdk/traceability/traceability.types'
import { sdk } from '../../services/sdk'

interface AuditItemDetailsDataContext {
  traceability?: IItemTraceability[]

  actions: {
    fetchItemTraceability: () => void
  }
}

interface AuditItemDetailsdProviderProps {
  children: React.ReactNode
}

export const AuditItemDetailsContext = createContext(
  {} as AuditItemDetailsDataContext,
)

export function AuditItemDetailsProvider(
  props: AuditItemDetailsdProviderProps,
) {
  const [traceability, setTraceability] = useState<IItemTraceability[]>()

  const { id } = useParams()

  const fetchItemTraceability = async () => {
    const _response = await sdk.items.getItemToAudit(id as string)
    setTraceability(_response)
  }

  return (
    <AuditItemDetailsContext.Provider
      value={{
        traceability,

        actions: {
          fetchItemTraceability,
        },
      }}
    >
      {props.children}
    </AuditItemDetailsContext.Provider>
  )
}
